import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import axios from "axios";

const API = "https://backendlab.vercel.app";

const formatTime = (isoString) => {
  const d = new Date(isoString);
  return d.toLocaleTimeString("pt-PT", { hour: "2-digit", minute: "2-digit" });
};

const getDayLabel = (isoString) => {
  const appt = new Date(isoString);
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);
  const sameDay = (a, b) =>
    a.getDate() === b.getDate() && a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
  if (sameDay(appt, today)) return "Hoje";
  if (sameDay(appt, tomorrow)) return "Amanhã";
  return appt.toLocaleDateString("pt-PT", { weekday: "long", day: "numeric", month: "long" });
};

const groupByDay = (appointments) => {
  const groups = {};
  appointments
    .filter((a) => !a.done)
    .sort((a, b) => new Date(a.dateTime) - new Date(b.dateTime))
    .forEach((appt) => {
      const label = getDayLabel(appt.dateTime);
      if (!groups[label]) groups[label] = [];
      groups[label].push(appt);
    });
  return groups;
};

const AgendaSidebar = ({ refreshKey }) => {
  const [appointments, setAppointments] = useState([]);
  const [viewingAppt, setViewingAppt] = useState(null);

  const fetchAppointments = async () => {
    try {
      const res = await axios.get(`${API}/appointments`);
      setAppointments(res.data);
    } catch (error) {
      console.error("Error fetching appointments:", error);
    }
  };

  useEffect(() => {
    fetchAppointments();
    const interval = setInterval(fetchAppointments, 2 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchAppointments();
  }, [refreshKey]);

  const handleDone = async (id) => {
    try {
      await axios.put(`${API}/appointments/${id}/done`);
      fetchAppointments();
    } catch (error) {
      console.error("Error marking appointment done:", error);
    }
  };

  const groups = groupByDay(appointments);
  const total = appointments.filter((a) => !a.done).length;

  return (
    <div className="agenda-sidebar">
      <div className="agenda-header">
        <div className="agenda-title-row">
          <span className="agenda-title">Agenda</span>
          {total > 0 && <span className="agenda-badge">{total}</span>}
        </div>
      </div>

      <div className="agenda-list">
        {Object.keys(groups).length === 0 ? (
          <div className="agenda-empty">Sem visitas agendadas</div>
        ) : (
          Object.entries(groups).map(([dayLabel, appts]) => (
            <div key={dayLabel} className="agenda-day-group">
              <div className="agenda-day-label">{dayLabel}</div>
              {appts.map((appt) => (
                <div
                  key={appt._id}
                  className="agenda-item"
                  onClick={() => setViewingAppt(appt)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="agenda-item-time">{formatTime(appt.dateTime)}</div>
                  <div className="agenda-item-body">
                    <div className="agenda-item-name">{appt.patientName}</div>
                    {appt.notes && <div className="agenda-item-notes">{appt.notes}</div>}
                  </div>
                  <button
                    className="agenda-done-btn"
                    onClick={(e) => { e.stopPropagation(); handleDone(appt._id); }}
                    title="Marcar como feito"
                  >
                    ✓
                  </button>
                </div>
              ))}
            </div>
          ))
        )}
      </div>

      {viewingAppt && (
        <Modal
          isOpen={!!viewingAppt}
          onRequestClose={() => setViewingAppt(null)}
          style={{
            content: {
              top: "50%", left: "50%", right: "auto", bottom: "auto",
              marginRight: "-50%", transform: "translate(-50%, -50%)",
              width: "300px", padding: "28px", backgroundColor: "#ffffff",
              borderRadius: "14px", boxShadow: "0 10px 30px rgba(0,0,0,0.14)", border: "none",
            },
          }}
        >
          <div className="agenda-modal-title">{viewingAppt.patientName}</div>
          <div className="agenda-modal-form">
            <label>Data e Hora</label>
            <div style={{ fontSize: "14px", color: "#1a2e3b", fontWeight: 600 }}>
              {new Date(viewingAppt.dateTime).toLocaleDateString("pt-PT")}
              {" às "}
              {formatTime(viewingAppt.dateTime)}
            </div>
            <label style={{ marginTop: 14 }}>Notas</label>
            <div style={{ fontSize: "14px", color: "#4f6070", minHeight: 36 }}>
              {viewingAppt.notes || "—"}
            </div>
          </div>
          <div className="agenda-modal-actions">
            <button className="agenda-modal-cancel" onClick={() => setViewingAppt(null)}>Fechar</button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default AgendaSidebar;